<template>
    <div>
        <button
            class="hidden xl:inline-block btn btn-md is-ghost"
            type="button"
            @click="$modal.show('move-addresses-to-delivery-project-for-sales-project')"
        >
            Assign all addresses
        </button>
        <button
            class="list-item xl:hidden"
            type="button"
            @click="$modal.show('move-addresses-to-delivery-project-for-sales-project')"
        >
            Assign all addresses
        </button>
        <adaptive-form-modal
            name="move-addresses-to-delivery-project-for-sales-project"
            primary-button-text="Assign all addresses"
            primary-button-class="is-primary"
            title="Assign all addresses to delivery project"
            method="post"
            :action="actionRoute"
            :callback="reloadPage"
        >
            <p>
                This will assign <span class="underline">all</span> addresses that are not Operational (&ldquo;I drift&rdquo;) to the selected delivery project.
            </p>

            <div class="form-group select form-group-floating-label">
                <select
                    v-model="targetDeliveryProjectId"
                    required
                    class="form-input"
                    name="target_delivery_project_id"
                >
                    <option
                        v-for="(id, name) in deliveryProjects"
                        :value="id"
                    >
                        {{ name }}
                    </option>
                </select>
                <label class="floating-label">
                    Delivery Project
                </label>
            </div>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            deliveryProjects: {
                type: Object,
                required: true,
            },
            salesProject: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                targetDeliveryProjectId: null,
            };
        },
        computed: {
            actionRoute() {
                return route('api.delivery-projects.move-addresses.update', this.salesProject);
            },
        },
        mounted() {
            if (this.deliveryProjects.length > 0) {
                this.targetDeliveryProjectId = this.deliveryProjects[0];
            }
        },
        methods: {
            reloadPage() {
                window.location = window.location.href;
            },
        },
    };
</script>
